import axios from '@axios'

const route = 'configuration/delivery'

export default {
  namespaced: true,
  actions: {
    getDeliverySettings() {
      return axios.get(route)
    },
    saveDeliverySettings(context, settings) {
      return axios.post(route, settings)
    },
    uploadDeliveryBackgroundImage(context, formData) {
      return axios.post(`${route}/background-image`, formData)
    },
    removeDeliveryBackgroundImage() {
      return axios.delete(`${route}/background-image`)
    },
    test99Connection(context, credentials) {
      return axios.post(`${route}/99/test`, credentials)
    },
  },
}
